import React from "react";
import { HelpCircle, Mail, Clock, FileWarning } from "lucide-react";
import Header from "../../components/user/Header";
import infoBg from "../../images/Baseball2.jpg";
import Footer from "../../components/user/Footer";

export default function Support() {
  return (
    <section style={{ background: "#f7f9fc" }}>
        <Header />
        <section
        className="py-5 position-relative text-white d-flex align-items-center"
        style={{
            backgroundImage: `url(${infoBg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            height: "400px",
        }}
        >
        {/* Dark Overlay */}
        <div
            style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.55)",
            zIndex: 1,
            }}
        ></div>

        {/* Content */}
        <div
            className="container text-center position-relative"
            style={{ zIndex: 2 }}
        >
            <h2 className="fw-bold display-6">SUPPORT</h2>
            <p className="lead mt-3">
              Get help, find answers, and contact the NLSA CHALLENGE support team.
              </p>
        </div>
        </section>
        <br />
      <div className="container">

        {/* Support Overview */}
        <div className="card shadow-sm border-0 rounded-4 p-4 mb-4 hover-scale">
          <div className="d-flex align-items-center mb-3">
            <HelpCircle size={36} className="text-primary me-3" />
            <h4 className="fw-bold mb-0">Support Overview</h4>
          </div>
          <p className="text-secondary mb-0">
            This page provides help, contact information, and guidance related to
            the NLSA CHALLENGE platform.
          </p>
        </div>

        {/* Common Support Topics */}
        <div className="card shadow-sm border-0 rounded-4 p-4 mb-4 hover-scale">
          <div className="d-flex align-items-center mb-3">
            <FileWarning size={36} className="text-primary me-3" />
            <h4 className="fw-bold mb-0">Common Support Topics</h4>
          </div>

          <ul className="text-secondary mb-0 ps-3">
            <li>Login issues</li>
            <li>Certificate access problems</li>
            <li>Stat verification questions</li>
            <li>Event registration questions</li>
            <li>Payment or fee questions</li>
          </ul>
        </div>

        {/* Refund Requests */}
        <div className="card shadow-sm border-0 rounded-4 p-4 mb-4 hover-scale">
          <h4 className="fw-bold mb-2">Refund Requests</h4>
          <p className="text-secondary mb-0">
            Refund requests are submitted inside the athlete dashboard. All
            refund requests are manually reviewed and processed by NLSA USA
            staff.
          </p>
        </div>

        {/* Contact Support */}
        <div className="card shadow-sm border-0 rounded-4 p-4 mb-4 hover-scale">
          <div className="d-flex align-items-center mb-3">
            <Mail size={36} className="text-primary me-3" />
            <h4 className="fw-bold mb-0">Contact Support</h4>
          </div>
          <p className="text-secondary mb-0">
            A support form or support email will appear on this page.<br />
            You can submit your message anytime.
          </p>
        </div>

        {/* Response Time */}
        <div className="card shadow-sm border-0 rounded-4 p-4 mb-4 hover-scale">
          <div className="d-flex align-items-center mb-3">
            <Clock size={36} className="text-primary me-3" />
            <h4 className="fw-bold mb-0">Response Time</h4>
          </div>
          <p className="text-secondary mb-0">
            Support messages are typically answered within{" "}
            <strong>24–48 hours</strong>.
          </p>
        </div>
      </div>

      {/* Hover Animation */}
      <style>{`
        .hover-scale {
          transition: 0.3s ease;
        }
        .hover-scale:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 25px rgba(0,0,0,0.15) !important;
        }
      `}</style>
      <Footer />
    </section>
  );
}